import type { Nullable } from "../../../../typescript"
import eightDirectionCharsLowerCase, { type EightDirectionCharLowerCase, type EightDirectionIndex } from "../../direction/eightDirectionCharsLowerCase"
import type { TileGraphNode } from "../TileGraphNode/TileGraphNode.type"
import type { TileGraphCorner } from "./TileGraphCorner.type"

export default function getEightDirectionIndexFrom<T>(
  nodeByLcMap: TileGraphCorner['node'],
  node0: T,
): Nullable<EightDirectionIndex> {
  for (let eightDirectionIndex : EightDirectionIndex = 0; eightDirectionIndex < eightDirectionCharsLowerCase.length; eightDirectionIndex++) {
    const lcChar : EightDirectionCharLowerCase = eightDirectionCharsLowerCase[eightDirectionIndex]
    const node1 : Nullable<TileGraphNode> = (nodeByLcMap as Partial<Record<EightDirectionCharLowerCase, Nullable<TileGraphNode>>>)[lcChar]
    if (node1 === node0) {
      return eightDirectionIndex as EightDirectionIndex
    }
  }
}